import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const STORAGE_KEY = "alfatek_cart_v1";

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (raw) setItems(JSON.parse(raw));
        } catch {}
    }, []);

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    }, [items]);

    const add = (product) => {
        setItems((prev) => {
            const idx = prev.findIndex((i) => i.product_id === product.id);
            if (idx >= 0) {
                const c = [...prev];
                c[idx] = { ...c[idx], quantity: (c[idx].quantity || 1) + 1 };
                return c;
            }
            return [...prev, {
                product_id: product.id,
                name: product.name,
                sku: product.sku || null,
                brand_name: product.brand?.name || null,
                image_url: product.image_url || null,
                quantity: 1,
                notes: "",
            }];
        });
    };

    const remove = (pid) => setItems((prev) => prev.filter((i) => i.product_id !== pid));
    const setQty = (pid, qty) => setItems((prev) => prev.map((i) => i.product_id === pid ? { ...i, quantity: Math.max(1, qty) } : i));
    const setNotes = (pid, notes) => setItems((prev) => prev.map((i) => i.product_id === pid ? { ...i, notes } : i));
    const clear = () => setItems([]);
    const count = items.reduce((s, i) => s + (i.quantity || 1), 0);

    return (
        <CartCtx.Provider value={{ items, add, remove, setQty, setNotes, clear, count }}>
            {children}
        </CartCtx.Provider>
    );
};

export const useCart = () => useContext(CartCtx);
